import { createAction, PayloadActionCreator } from '@reduxjs/toolkit';

const loading = (prefix: string): PayloadActionCreator => createAction<void, string>(prefix + '_STATE_SET_LOADING');
const data = (prefix: string): PayloadActionCreator => createAction<void, string>(prefix + '_STATE_SET_DATA');
const error = (prefix: string): PayloadActionCreator<{ code: string }> =>
  createAction<{ code: string }>(prefix + '_STATE_SET_ERROR');
const success = (prefix: string): PayloadActionCreator => createAction<void, string>(prefix + '_STATE_SET_SUCCESS');
const custom = (prefix: string): PayloadActionCreator<string> => createAction(prefix + '_STATE_SET_CUSTOM');

function setLoading(prefix: string): any {
  return loading(prefix)();
}

function setData(prefix: string): any {
  return data(prefix)();
}

function setError(prefix: string, code: string): any {
  return error(prefix)({ code });
}

function setSuccess(prefix: string): any {
  return success(prefix)();
}

function setCustom(prefix: string, state: string): any {
  return custom(prefix)(state);
}

export default {
  loading,
  data,
  error,
  success,
  custom,
  setLoading,
  setData,
  setError,
  setSuccess,
  setCustom
};
